// extracted by mini-css-extract-plugin
module.exports = {"sessionInfo":"SessionInfo_sessionInfo_tio0g","gameInfo__season":"SessionInfo_gameInfo__season_2VaEg"};